
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "PopupSuccess"
})
export default class PopupContainer extends Vue {
  handleClick() {
    this.$store.dispatch("app/togglePopupAction");
  }
}
